import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  multiPackageTitle: {
    defaultMessage: 'Package Configuration',
    description: 'Title for the Package Configuration drag and drop modal',
    id: 'ZHtasl',
  },
  packageModalAlertTitle: {
    defaultMessage: 'Confirm',
    description: 'Title for confirmation modal when saving with empty packages',
    id: 'ix0y4U',
  },
  emptyPackageModalHeading: {
    defaultMessage: 'Package with no items',
    description: 'Heading in confirmation modal warning about empty packages',
    id: 'xFXBb1',
  },
  emptyPackageModalMessage: {
    defaultMessage: 'One or more packages have no items assigned. Empty packages will still be included in this shipment.',
    description: 'Warning message explaining that empty packages will be included in the shipment',
    id: 'Hxrnyi',
  },
  confirmButton: {
    defaultMessage: 'Confirm',
    description: 'Button to confirm saving packages despite having empty ones',
    id: 'M+UqdO',
  },
  cancelButton: {
    defaultMessage: 'Cancel',
    description: 'Button to cancel and return to editing packages',
    id: 'UPdhtn',
  },
  saveNewPackageSet: {
    defaultMessage: 'Save New Package Set',
    description: 'Checkbox label to save the current package configuration as a reusable package set',
    id: '8W7MwV',
  },
  savePackagesButton: {
    defaultMessage: 'Save Packages',
    description: 'Button to save all package configurations and close the modal',
    id: 'bZ9Kb/',
  },
  packageSetNameLabel: {
    defaultMessage: 'Package Set Name',
    description: 'Label for input where user can enter a name to save their package configuration as a package set',
    id: 'i5UePR',
  },
  unassignedItemsModalHeading: {
    defaultMessage: 'Items not assigned to a package',
    description: 'Heading in confirmation modal warning about unassigned items',
    id: 'lwYv1M',
  },
  unassignedItemsModalMessage: {
    defaultMessage: 'Some items have not been assigned to a package. They will be automatically assigned to Package 1.',
    description: 'Warning message explaining that unassigned items will be assigned to the first package',
    id: '8AOum3',
  },
  multiPackageNotSupported: {
    description: 'banner message for multi-package not supported',
    defaultMessage: 'Selected carrier does not support multi-package shipping. You will need to select a new service.',
    id: '1Hjfjb',
  },
});
